import { base } from "./base";

export const cz = { ...base };
